import request from 'utils/request';
import config from 'config/Config';
import { hex_md5, Encrypts } from 'utils/md5';
import { decryptParams, orderParams } from 'utils/constants';

export default class {
  // 获取基本信息
  static getOrderInfo(tradeNo, params, fromQRCode) {
    if (fromQRCode)
      params.md5Sign = hex_md5((tradeNo || '').replace(/\s*/g, '') + orderParams).toUpperCase();
    return request({
      url: `tradecore/order/details/info${fromQRCode ? '/scan' : ''}/${tradeNo}`,
      host: config.HOST_MALL,
      params
    });
  }

  // 获取不能快速退单的指定产品
  static getNotFastRefund() {
    return request({
      url: 'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/image/app/notFastRefund.json',
      method: 'get',
      withCredentials: false,
      ignoreErr: true
    });
  }
  // /**
  //  * 获取商品列表
  //  */
  // static getOrderProduct(tradeNo, params) {
  //   return request({
  //     url: `tradecore/order/details/item/${tradeNo}`,
  //     host: config.HOST_MALL,
  //     params,
  //   });
  // }

  // /**
  //  * 包裹物流信息
  //  */
  // static getDeliveryMsg(params) {
  //   return request({
  //     url: `tradecore/order/details/deliveryMsg`,
  //     host: config.HOST_MALL,
  //     params,
  //   });
  // }

  /**
   * 修改订单
   * @param {} tradeNo
   */
  static modifyOrder(tradeNo) {
    return request({
      url: `tradecore/order/modifyorder/${tradeNo}`,
      host: config.HOST_MALL,
      method: 'post_json'
    });
  }

  /**
   * 查询发货单列表
   */
  static getDeliveryList(tradeNo, fromQRCode) {
    const params = {};
    if (fromQRCode)
      params.md5Sign = hex_md5((tradeNo || '').replace(/\s*/g, '') + orderParams).toUpperCase();
    return request({
      url: `tradecore/order/details/item-delivery/package${fromQRCode ? '/scan' : ''}/${tradeNo}`,
      host: config.HOST_MALL,
      params
    });
  }

  static getComment(params) {
    return request({
      url: `tradecore/comment/query/${params}`,
      host: config.HOST_MALL
    });
  }

  /**
   * 获取订单活动信息
   */
  static getOrderActivity(tradeNo, fromQRCode) {
    const params = {};
    if (fromQRCode)
      params.md5Sign = hex_md5((tradeNo || '').replace(/\s*/g, '') + orderParams).toUpperCase();
    return request({
      url: `tradecore/order/details/active-info${fromQRCode ? '/scan' : ''}/${tradeNo}`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取活动信息
   */
  static getActivityGoodsInfo(goodsId, activityId) {
    return request({
      url: `promotion/${activityId}/${goodsId}`,
      host: config.HOST_MALL
    });
  }

  /**
   * 获取订单优惠券信息
   */
  static getCouponMsg(tradeNo, fromQRCode) {
    const params = {};
    if (fromQRCode)
      params.md5Sign = hex_md5((tradeNo || '').replace(/\s*/g, '') + orderParams).toUpperCase();
    return request({
      url: `tradecore/order/details/discount${fromQRCode ? '/scan' : ''}/${tradeNo}`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 确认收货
   */
  static takeOver(params) {
    return request({
      url: 'tradecore/order/part-delivery',
      host: config.HOST_MALL,
      method: 'post_json',
      params
    });
  }

  // 取消订单
  static cancelOrder(tradeNo) {
    return request({
      url: `tradecore/order/cancel/${tradeNo}`,
      host: config.HOST_MALL,
      method: 'post_json'
    });
  }

  // 提交评论
  static commitCommet(params) {
    return request({
      url: `tradecore/comment/add`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  // 订单详情-赠品信息
  static getOrderGiftItem(tradeNo, params, fromQRCode) {
    if (fromQRCode)
      params.md5Sign = hex_md5((tradeNo || '').replace(/\s*/g, '') + orderParams).toUpperCase();
    return request({
      url: `tradecore/order/details/gift-item${fromQRCode ? '/scan' : ''}/${tradeNo}`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 加价购商品列表
   */
  static getIncPriceShop(tradeNo, fromQRCode) {
    const params = {};
    if (fromQRCode)
      params.md5Sign = hex_md5((tradeNo || '').replace(/\s*/g, '') + orderParams).toUpperCase();
    return request({
      url: `tradecore/order/details/cheap-item${fromQRCode ? '/scan' : ''}/${tradeNo}`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 拼团预售校验
   * 预售-支付尾款阶段时校验是否支付定金
   * 拼团-是否有当前商品的未成功的拼团
   */
  static checkCanBuy(params) {
    let { type, activityId, itemId, tradeNo } = params;
    let url = `biz/tradecore/trade/confirmGroupSale/${type}/activity/${activityId}/item/${itemId}/tradeNo`;
    if (tradeNo) {
      url += '/' + tradeNo;
    }
    return request({
      url: url,
      host: config.HOST_MALL,
      method: 'post_json'
    });
  }

  /**
   * 申请售后提交
   */
  static afterSaleApply(data) {
    return request({
      // url: `tradecore/after-sale/apply/save`,
      url: `tradecore/after-sale/check/upgradeSplitOrder`,
      host: config.HOST_MALL,
      method: 'POST_JSON',
      data
    });
  }

  /**
   * 延迟发货
   * @param {} tradeNo
   */
  static doDelay(tradeNo) {
    return request({
      url: `tradecore/order/delay/${tradeNo}`,
      host: config.HOST_MALL,
      method: 'post'
    });
  }

  /**
   * 获取协议
   */
  static getAgreement(code) {
    return request({
      url: `basic/contract/query/${code}`,
      host: config.HOST_MALL
    });
  }

  /**
   * 删除订单
   */
  static deleteOrder(tradeNo) {
    return request({
      url: `tradecore/order/client/close/${tradeNo}`,
      host: config.HOST_MALL,
      method: 'post'
    });
  }

  static checkICanPay(data) {
    return request({
      url: `tradecore/member/checkOpenIdIsSelf`,
      host: config.HOST_MALL,
      method: 'POST_JSON',
      data
    });
  }

  /**
   * 查询是否存在关联订单
   */
  static checkRelateOrder(params) {
    return request({
      url: 'tradecore/after-sale/check/singleReturn',
      method: 'POST_JSON',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/TradeManage/OrderList/Detail/DetailServ.js